export default function SortDescIcon({ className = '' }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
    >
      <path d="M10 6l5 5H5l5-5z" />
    </svg>
  );
}
